export { LicenseModal } from './LicenseModal.component';
